import BodyParts from 'constants/bodyParts.constants';

export const FOCUS_SEGMENTS = [
  { label: BodyParts.pelvis, key: 'pelvisFocus' },
  { label: BodyParts.torso, key: 'torsoFocus' },
  { label: BodyParts.upperArm, key: 'upperArmFocus' },
  { label: BodyParts.hand, key: 'handFocus' }
];
